import { useEffect } from "react";

export function useDebug(...args: Array<any>) {
  useEffect(() => {
    console.log(...args);
    // Disabling because the useEffect is intentionally rerunning based on any arg change
    // oxlint-disable-next-line exhaustive-deps
  }, args);
}
